import { apiFetch } from "./client";

export interface ConfecamarasRecord {
  codigo_camara?: string;
  camara_comercio?: string;
  matricula?: string;
  inscripcion_proponente?: string;
  razon_social?: string;
  clase_identificacion?: string;
  numero_identificacion?: string;
  nit?: string;
  digito_verificacion?: string;
  cod_ciiu_act_econ_pri?: string;
  fecha_matricula?: string;
  fecha_renovacion?: string;
  ultimo_ano_renovado?: string;
  fecha_vigencia?: string;
  tipo_sociedad?: string;
  organizacion_juridica?: string;
  categoria_matricula?: string;
  estado_matricula?: string;
  fecha_actualizacion?: string;
  [key: string]: unknown;
}

export interface ProgresoConsulta {
  type: "progress";
  nit: string;
  status: "ok" | "not_found" | "error";
  razon_social?: string | null;
  camara_comercio?: string | null;
  estado_matricula?: string | null;
  cantidad_registros: number;
  records: ConfecamarasRecord[];
  error?: string | null;
}

export type WsMensaje =
  | { type: "start"; total: number }
  | ProgresoConsulta
  | {
      type: "done";
      total_ok: number;
      total_not_found: number;
      total_error: number;
    }
  | { type: "error"; message: string };

export interface ConsultaRow {
  id: number;
  nit: string;
  razon_social?: string | null;
  camara_comercio?: string | null;
  estado_matricula?: string | null;
  cantidad_registros: number;
  status: string;
  created_at: string | null;
}

export interface ConsultaDetail {
  id: number;
  nit: string;
  status: string;
  error_message?: string | null;
  raw_response: ConfecamarasRecord[];
  created_at: string;
}

export interface ConsultaPagination {
  total: number;
  page: number;
  limit: number;
  total_pages: number;
}

export const startConsultaNits = (params: {
  nits: string[];
  file?: File | null;
}) => {
  if (params.file) {
    const formData = new FormData();
    formData.append("file", params.file);
    return apiFetch<{ client_id: string; total: number }>(
      "/api/v1/confecamaras/consultar/upload",
      { method: "POST", body: formData },
    );
  }
  return apiFetch<{ client_id: string; total: number }>(
    "/api/v1/confecamaras/consultar",
    {
      method: "POST",
      body: JSON.stringify({ nits: params.nits }),
    },
  );
};

export const listConsultas = (params: {
  page?: number;
  limit?: number;
  q?: string;
  nit?: string;
}) =>
  apiFetch<{ data: ConsultaRow[]; pagination: ConsultaPagination }>(
    "/api/v1/confecamaras/consultas",
    {
      params: {
        page: params.page ?? 1,
        limit: params.limit ?? 50,
        q: params.q ?? "",
        nit: params.nit ?? "",
      },
    },
  );

export const getConsulta = (id: number) =>
  apiFetch<ConsultaDetail>(`/api/v1/confecamaras/consultas/${id}`);

export const openConsultaWebSocket = (
  clientId: string,
  onMessage: (msg: WsMensaje) => void,
  onClose?: () => void,
): WebSocket => {
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  const socket = new WebSocket(
    `${protocol}//${window.location.host}/ws/confecamaras/consultar/${clientId}`,
  );
  socket.onmessage = (event) => {
    try {
      const parsed = JSON.parse(event.data) as WsMensaje;
      onMessage(parsed);
    } catch {
      // ignora payloads mal formados
    }
  };
  socket.onclose = () => onClose?.();
  return socket;
};
